import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function StarRating({ track, size = "sm", className = "" }) {
  const { user } = useAuth();
  const [avg, setAvg] = useState(track.rating_avg || 0);
  const [count, setCount] = useState(track.rating_count || 0);
  const [mine, setMine] = useState(null);
  const [hover, setHover] = useState(0);

  useEffect(() => {
    if (!user) { setMine(null); return; }
    api.get(`/tracks/${track.id}/rating`).then((r) => { setMine(r.data.mine); setAvg(r.data.avg); setCount(r.data.count); }).catch(() => {});
  }, [user, track.id]);

  const rate = async (e, stars) => {
    e.stopPropagation(); e.preventDefault();
    if (!user) {
      toast.info("Inicia sesión para puntuar", {
        action: { label: "Entrar", onClick: () => { window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(window.location.href)}`; } },
      });
      return;
    }
    try {
      const r = await api.post(`/tracks/${track.id}/rate`, { stars });
      setMine(r.data.mine); setAvg(r.data.avg); setCount(r.data.count);
      toast.success(`Has puntuado con ${stars} estrella${stars === 1 ? "" : "s"}`);
    } catch { toast.error("No se pudo guardar la puntuación"); }
  };

  const shown = hover || mine || Math.round(avg);
  const px = size === "lg" ? "w-6 h-6" : "w-3.5 h-3.5";
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid={`star-rating-${track.id}`} onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" data-testid={`star-${n}-${track.id}`} onMouseEnter={() => setHover(n)} onClick={(e) => rate(e, n)}
            className="p-0.5 transition-transform hover:scale-110" title={user ? `Puntuar ${n}` : "Inicia sesión para puntuar"}>
            <Star className={`${px} ${n <= shown ? "fill-amber-400 text-amber-400" : "text-white/25"}`} />
          </button>
        ))}
      </div>
      <span className={`font-mono text-white/50 ${size === "lg" ? "text-sm" : "text-[10px]"}`} data-testid={`rating-summary-${track.id}`}>
        {count > 0 ? `${avg.toFixed(1)} · ${count}` : "Sin votos"}
      </span>
    </div>
  );
}
